module.exports = __webpack_public_path__ + "static/estimote-logo-54c832039cad864c6947a8eb5ac87f6e.png";